var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import EdModal from "../edModal";
import { getFinancialYear, pnlDownloadDate, previousDay, TodaysDate, } from "@domains/utils/reportDates";
import "@frameworks/web/stylesheets/components/Reports/PandLReports/ProfitAndLoss.scss";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
var CalendarPopupDesk = function (props) {
    var _a, _b, _c;
    var _d = __read(useState(false), 2), custom = _d[0], setCustom = _d[1];
    var _e = __read(useState(false), 2), openYear = _e[0], setOpenYear = _e[1];
    var currentYear = new Date().getFullYear();
    var _f = __read(React.useState(props.endDate), 2), endDate = _f[0], setEndDate = _f[1];
    var _g = __read(React.useState(props.startDate), 2), startDate = _g[0], setStartDate = _g[1];
    var years = Array.from(new Array(6), function (val, index) { return currentYear - index; });
    var onChange = function (dates) {
        var _a = __read(dates, 2), start = _a[0], end = _a[1];
        setStartDate(start);
        setEndDate(end);
    };
    var _calendar = useRef(null);
    var showDatePicker = function (e) {
        if (_calendar.current) {
            _calendar.current.setOpen(true);
        }
    };
    var handleApply = function () {
        // props?.dateChangeFilterData() ? props?.dateChangeFilterData() : null;
        var localStartDate = null, localEndDate = null;
        localStartDate = startDate;
        localEndDate = endDate;
        props.setStartDate(startDate);
        props.setEndDate(endDate);
        props.setFinYear(startDate.getFullYear());
        if ((props === null || props === void 0 ? void 0 : props.setNextFinYear) !== null && (props === null || props === void 0 ? void 0 : props.setNextFinYear) !== undefined) {
            if (startDate.getFullYear() === endDate.getFullYear())
                props.setNextFinYear(endDate.getFullYear() + 1);
            else
                props.setNextFinYear(endDate.getFullYear());
        }
        if ((props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== null &&
            (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== undefined &&
            typeof (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) === "function") {
            props === null || props === void 0 ? void 0 : props.dateChangeFilterData(localStartDate, localEndDate, false, false);
        }
        if ((props === null || props === void 0 ? void 0 : props.setShowCustomTimeRangeOnly) !== null &&
            (props === null || props === void 0 ? void 0 : props.setShowCustomTimeRangeOnly) !== undefined &&
            typeof (props === null || props === void 0 ? void 0 : props.setShowCustomTimeRangeOnly) === "function") {
            if (!(props === null || props === void 0 ? void 0 : props.customValidations(localStartDate, localEndDate))) {
                props === null || props === void 0 ? void 0 : props.setShowCustomTimeRangeOnly(false);
            }
        }
        else {
            setCustom(false);
        }
    };
    var handleCustom = function () {
        //props?.dateChangeFilterData() ? props?.dateChangeFilterData() : null;
        setCustom(!custom);
        props.setShowWeek && props.setShowWeek(false);
        props.setShowMonth && props.setShowMonth(false);
        props.setOpenCalendar(false);
        if ((props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== null &&
            (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== undefined &&
            typeof (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) === "function") {
            props === null || props === void 0 ? void 0 : props.dateChangeFilterData(startDate, endDate, false, false);
        }
    };
    var setFinYear = function (index) {
        //  props?.dateChangeFilterData() ? props?.dateChangeFilterData() : null;
        var localStartDate = null, localEndDate = null;
        setOpenYear(false);
        props.setShowWeek && props.setShowWeek(false);
        props.setShowMonth && props.setShowMonth(false);
        props.setOpenCalendar(false);
        props.setFinYear(currentYear - index);
        props.setNextFinYear(currentYear - index + 1);
        localStartDate = new Date(currentYear - index, 3, 1);
        props.setStartDate(new Date(currentYear - index, 3, 1));
        if (index === 0) {
            if ((props === null || props === void 0 ? void 0 : props.skipForFinalYear) !== null &&
                (props === null || props === void 0 ? void 0 : props.skipForFinalYear) !== undefined &&
                (props === null || props === void 0 ? void 0 : props.skipForFinalYear)) {
                localEndDate = new Date(currentYear - index + 1, 2, 31);
                props.setEndDate(new Date(currentYear - index + 1, 2, 31));
            }
            else {
                localEndDate = props.ToDatemax ? props.ToDatemax : previousDay;
                props.setEndDate(props.ToDatemax ? props.ToDatemax : previousDay);
            }
        }
        else {
            localEndDate = new Date(currentYear - index + 1, 2, 31);
            props.setEndDate(new Date(currentYear - index + 1, 2, 31));
        }
        if ((props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== null &&
            (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== undefined &&
            typeof (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) === "function") {
            props === null || props === void 0 ? void 0 : props.dateChangeFilterData(localStartDate, localEndDate, false, false);
        }
    };
    var setThisMonth = function () {
        //  props?.dateChangeFilterData() ? props?.dateChangeFilterData() : null;
        var localStartDate = null, localEndDate = null;
        props.setShowWeek && props.setShowWeek(false);
        props.setShowMonth && props.setShowMonth(true);
        props.setOpenCalendar(false);
        localStartDate = new Date(currentYear, new Date().getMonth(), 1);
        localEndDate = props.todaysDate
            ? TodaysDate
            : props.ToDatemax
                ? props.ToDatemax
                : previousDay;
        props.setStartDate(new Date(currentYear, new Date().getMonth(), 1));
        props.todaysDate
            ? props.setEndDate(TodaysDate)
            : props.setEndDate(props.ToDatemax ? props.ToDatemax : previousDay);
        props.setFinYear(currentYear);
        props.setNextFinYear(currentYear + 1);
        if (!!(props === null || props === void 0 ? void 0 : props.setEndOfMonth) && props.setEndOfMonth) {
            localEndDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
            props.setEndDate(localEndDate);
        }
        else if (new Date().getDate() === 1) {
            localEndDate = new Date();
            props.setEndDate(new Date());
        }
        if ((props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== null &&
            (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== undefined &&
            typeof (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) === "function") {
            props === null || props === void 0 ? void 0 : props.dateChangeFilterData(localStartDate, localEndDate, true, false);
        }
    };
    var setLastMonth = function () {
        // props?.dateChangeFilterData() ? props?.dateChangeFilterData() : null;
        props.setShowWeek && props.setShowWeek(false);
        props.setShowMonth && props.setShowMonth(false);
        props.setOpenCalendar(false);
        props.setStartDate(new Date(currentYear, new Date().getMonth() - 1, 1));
        props.setEndDate(new Date(currentYear, new Date().getMonth(), 0));
        props.setFinYear(getFinancialYear());
        props.setNextFinYear(getFinancialYear() + 1);
        if ((props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== null &&
            (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== undefined &&
            typeof (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) === "function") {
            props === null || props === void 0 ? void 0 : props.dateChangeFilterData(new Date(currentYear, new Date().getMonth() - 1, 1), new Date(currentYear, new Date().getMonth(), 0), false, false);
        }
    };
    var setQuarter = function (index) {
        // props?.dateChangeFilterData() ? props?.dateChangeFilterData() : null;
        var startDate = null, endDate = null;
        props.setShowWeek && props.setShowWeek(false);
        props.setShowMonth && props.setShowMonth(false);
        props.setOpenCalendar(false);
        props.setFinYear(currentYear);
        var quarter = Math.ceil((new Date().getMonth() + 1) / 3) - index;
        if (quarter === 1) {
            if ((props === null || props === void 0 ? void 0 : props.lastQuarter) && (props === null || props === void 0 ? void 0 : props.lastQuarterYear) > 0) {
                if (new Date().getMonth() < 3) {
                    props === null || props === void 0 ? void 0 : props.setFinYear(currentYear - 1);
                    props.setNextFinYear(currentYear);
                    startDate = new Date(currentYear, 0, 1);
                    endDate = new Date(currentYear, 3, 0);
                    props.setStartDate(new Date(currentYear, 0, 1));
                    props.setEndDate(new Date(currentYear, 3, 0));
                }
                else {
                    props.setFinYear(props === null || props === void 0 ? void 0 : props.lastQuarterYear);
                    props.setNextFinYear((props === null || props === void 0 ? void 0 : props.lastQuarterYear) + 1);
                    startDate = new Date(props.lastQuarterYear + 1, 0, 1);
                    endDate = new Date(props.lastQuarterYear + 1, 3, 0);
                    props.setStartDate(new Date(props.lastQuarterYear + 1, 0, 1));
                    props.setEndDate(new Date(props.lastQuarterYear + 1, 3, 0));
                }
            }
            else {
            }
        }
        else if (quarter === 2) {
            startDate = new Date(currentYear, 3, 1);
            endDate = new Date(currentYear, 6, 0);
            props.setStartDate(new Date(currentYear, 3, 1));
            props.setEndDate(new Date(currentYear, 6, 0));
        }
        else if (quarter === 3) {
            startDate = new Date(currentYear, 6, 1);
            endDate = new Date(currentYear, 9, 0);
            props.setStartDate(new Date(currentYear, 6, 1));
            props.setEndDate(new Date(currentYear, 9, 0));
        }
        else if (quarter === 4) {
            startDate = new Date(currentYear, 9, 1);
            endDate = new Date(currentYear, 12, 0);
            props.setStartDate(new Date(currentYear, 9, 1));
            props.setEndDate(new Date(currentYear, 12, 0));
        }
        else {
            props.setFinYear(currentYear - 1);
            props.setNextFinYear(currentYear);
            startDate = new Date(currentYear - 1, 9, 1);
            endDate = new Date(currentYear - 1, 12, 0);
            props.setStartDate(new Date(currentYear - 1, 9, 1));
            props.setEndDate(new Date(currentYear - 1, 12, 0));
        }
        if (!(props === null || props === void 0 ? void 0 : props.skipForQuarter) && index === 0) {
            endDate = props.ToDatemax ? props.ToDatemax : previousDay;
            props.setEndDate(props.ToDatemax ? props.ToDatemax : previousDay);
        }
        if ((props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== null &&
            (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) !== undefined &&
            typeof (props === null || props === void 0 ? void 0 : props.dateChangeFilterData) === "function") {
            props === null || props === void 0 ? void 0 : props.dateChangeFilterData(startDate, endDate, false, false);
        }
    };
    React.useEffect(function () {
        if (props.startDate)
            setStartDate(props.startDate);
        if (props.endDate)
            setEndDate(props.endDate);
    }, [props.startDate, props.endDate]);
    React.useEffect(function () {
        if (!props.openCalendar)
            setOpenYear(false);
    }, [props.openCalendar]);
    var DatePickerButton = React.forwardRef(function (_a, calendarInputRef) {
        var value = _a.value, onClick = _a.onClick;
        return (React.createElement("a", { 
            // href="#"
            className: "custom-input p-2 rangeDatePicker", onClick: onClick, ref: calendarInputRef }, value));
    });
    var DatePickerButtonToDate = React.forwardRef(function (_a, calendarInputRef) {
        var value = _a.value, onClick = _a.onClick;
        return (React.createElement("a", { 
            // href="#"
            className: "custom-input p-2 rangeDatePicker", onClick: onClick, ref: calendarInputRef }, value));
    });
    var getCustomPopupConditionValue = function () {
        var conditionVariable = custom;
        if ((props === null || props === void 0 ? void 0 : props.showCustomTimeRangeOnly) !== null &&
            (props === null || props === void 0 ? void 0 : props.showCustomTimeRangeOnly) !== undefined &&
            (props === null || props === void 0 ? void 0 : props.showCustomTimeRangeOnly)) {
            conditionVariable = props === null || props === void 0 ? void 0 : props.showCustomTimeRangeOnly;
        }
        return conditionVariable;
    };
    var isWeekday = function (date) {
        if ((props === null || props === void 0 ? void 0 : props.filterDate) !== null &&
            (props === null || props === void 0 ? void 0 : props.filterDate) !== undefined &&
            typeof (props === null || props === void 0 ? void 0 : props.filterDate) === "function") {
            return props === null || props === void 0 ? void 0 : props.filterDate(date);
        }
        else {
            return true;
        }
    };
    var isWeekdayRange = function (date) {
        if ((props === null || props === void 0 ? void 0 : props.rangeFilterDate) !== null &&
            (props === null || props === void 0 ? void 0 : props.rangeFilterDate) !== undefined &&
            typeof (props === null || props === void 0 ? void 0 : props.rangeFilterDate) === "function") {
            return props === null || props === void 0 ? void 0 : props.rangeFilterDate(date);
        }
        else {
            return true;
        }
    };
    //console.log("Selected Start End Date Popup", startDate, endDate);
    return (React.createElement("div", { style: { display: "inline" } },
        props.openCalendar && (React.createElement("div", null,
            React.createElement("div", { className: "calendar_container" },
                React.createElement("div", { className: "calendar_arrow" }),
                React.createElement("div", { className: "calendar_list" },
                    React.createElement("span", { onClick: function () {
                            setThisMonth();
                        } }, "This Month"),
                    React.createElement("span", { onClick: function () {
                            setLastMonth();
                        } }, "Last Month"),
                    React.createElement("span", { onClick: function () {
                            setQuarter(0);
                        } }, "This Quarter"),
                    React.createElement("span", { onClick: function () {
                            setQuarter(1);
                        } }, "Last Quarter"),
                    React.createElement("span", { className: "yearly", onClick: function () {
                            setOpenYear(!openYear);
                        } },
                        "Yearly",
                        React.createElement("i", { className: "edel-icon-arrow-right1" })),
                    props.customTime && (React.createElement("span", { onClick: function () {
                            handleCustom();
                        } },
                        "Custom Time Range",
                        React.createElement("i", { className: "edel-icon-arrow-right1" })))),
                openYear && (React.createElement("div", { className: "year_container" }, years.map(function (finYear, index) {
                    return (React.createElement("div", { className: "financial_year", key: index },
                        React.createElement("span", { onClick: function () { return setFinYear(index); } },
                            "FY \u00A0",
                            finYear,
                            "-",
                            (finYear + 1).toString().substring(2))));
                })))))),
        React.createElement("div", { className: "calendar_pnl_ui" },
            React.createElement(EdModal, { show: getCustomPopupConditionValue(), setShow: function (resp) {
                    if ((props === null || props === void 0 ? void 0 : props.setShowCustomTimeRangeOnly) !== null &&
                        (props === null || props === void 0 ? void 0 : props.setShowCustomTimeRangeOnly) !== undefined &&
                        typeof (props === null || props === void 0 ? void 0 : props.setShowCustomTimeRangeOnly) === "function") {
                        props === null || props === void 0 ? void 0 : props.setShowCustomTimeRangeOnly(resp);
                    }
                    else {
                        setCustom(resp);
                    }
                }, modalTitle: "modalHoldingTitle", title: "Custom Time Range", showFooter: false },
                React.createElement("div", { className: "pandLcalendar" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12 col-lg-12 pandLcalendar-form" },
                            React.createElement("div", { className: "row calendar--row" },
                                React.createElement("div", { className: "col pdr-0" },
                                    React.createElement("label", { htmlFor: "", className: "toDate" }, "From Date"),
                                    React.createElement("div", { className: "inputFieldCalendarIcon input-group yearDropdown singleDatePicker holdingReportsDate sales-calendar-wrapper" },
                                        React.createElement(DatePicker, { selected: startDate, onChange: function (date) {
                                                setStartDate(date);
                                                if ((props === null || props === void 0 ? void 0 : props.showCustomTimeRangeOnly) !== null &&
                                                    (props === null || props === void 0 ? void 0 : props.showCustomTimeRangeOnly) !== undefined &&
                                                    (props === null || props === void 0 ? void 0 : props.showCustomTimeRangeOnly)) {
                                                    setEndDate(date);
                                                }
                                            }, ref: _calendar, dateFormat: "d-MMM-yy", filterDate: isWeekday, formatWeekDay: function (nameOfDay) {
                                                return nameOfDay.slice(0, 1);
                                            }, excludeDates: ((_a = props === null || props === void 0 ? void 0 : props.holidayList) === null || _a === void 0 ? void 0 : _a.length) > 0
                                                ? props === null || props === void 0 ? void 0 : props.holidayList
                                                : [], minDate: (props === null || props === void 0 ? void 0 : props.ToDateMin)
                                                ? (props === null || props === void 0 ? void 0 : props.otherMinDate)
                                                    ? props === null || props === void 0 ? void 0 : props.otherMinDate
                                                    : props === null || props === void 0 ? void 0 : props.ToDateMin
                                                : pnlDownloadDate, maxDate: props.ToDatemax ? props.ToDatemax : previousDay, showYearDropdown: true, showMonthDropdown: true, customInput: React.createElement(DatePickerButton, null), scrollableYearDropdown: true }),
                                        React.createElement("span", { className: "input-group-text" },
                                            React.createElement("i", { className: "edel-icon-calendar-report" }),
                                            React.createElement("span", null, "Change")))),
                                React.createElement("div", { className: "col pdl-0" },
                                    React.createElement("label", { htmlFor: "", className: "toDate" }, "To Date"),
                                    React.createElement("div", { className: "inputFieldCalendarIcon input-group yearDropdown singleDatePicker holdingReportsDate" },
                                        React.createElement(DatePicker, { selected: endDate, onChange: function (date) { return setEndDate(date); }, ref: _calendar, dateFormat: "d-MMM-yy", formatWeekDay: function (nameOfDay) {
                                                return nameOfDay.slice(0, 1);
                                            }, filterDate: isWeekday, minDate: props.isMinDate
                                                ? props.otherMinDate
                                                    ? props.otherMinDate
                                                    : (props === null || props === void 0 ? void 0 : props.ToDateMin)
                                                        ? props === null || props === void 0 ? void 0 : props.ToDateMin
                                                        : startDate
                                                : pnlDownloadDate, excludeDates: ((_b = props === null || props === void 0 ? void 0 : props.holidayList) === null || _b === void 0 ? void 0 : _b.length) > 0
                                                ? props === null || props === void 0 ? void 0 : props.holidayList
                                                : [], maxDate: (props === null || props === void 0 ? void 0 : props.otherMaxDate)
                                                ? props === null || props === void 0 ? void 0 : props.otherMaxDate
                                                : props.ToDatemax
                                                    ? props.ToDatemax
                                                    : previousDay, showYearDropdown: true, showMonthDropdown: true, customInput: React.createElement(DatePickerButton, null), scrollableYearDropdown: true }),
                                        React.createElement("span", { className: "input-group-text" },
                                            React.createElement("i", { className: "edel-icon-calendar-report" }),
                                            React.createElement("span", null, "Change"))))),
                            React.createElement("div", { className: "yearDropdown singleDatePicker holdingReportsDate rangeDatePickerContainer sales-calendar-wrapper" },
                                " ",
                                React.createElement(DatePicker, { dateFormat: "d-MMM-yy", onChange: onChange, startDate: startDate, endDate: endDate, selectsRange: true, inline: true, filterDate: isWeekdayRange, minDate: props.isMinDate
                                        ? (props === null || props === void 0 ? void 0 : props.ToDateMin)
                                            ? props === null || props === void 0 ? void 0 : props.ToDateMin
                                            : startDate
                                        : pnlDownloadDate, excludeDates: ((_c = props === null || props === void 0 ? void 0 : props.holidayList) === null || _c === void 0 ? void 0 : _c.length) > 0 ? props === null || props === void 0 ? void 0 : props.holidayList : [], disabled: (props === null || props === void 0 ? void 0 : props.isDisabled) ? props === null || props === void 0 ? void 0 : props.isDisabled : false, maxDate: props.ToDatemax ? props.ToDatemax : previousDay, formatWeekDay: function (nameOfDay) { return nameOfDay.slice(0, 1); }, showYearDropdown: true, showMonthDropdown: true, scrollableYearDropdown: true })))),
                    React.createElement("div", { className: "custom_buttons" },
                        React.createElement("button", { onClick: function () { return setCustom(false); } }, "Cancel"),
                        React.createElement(EdButton, { className: "active", onClick: handleApply, disabled: startDate && endDate ? false : true, value: " Apply", btnTyp: "blue-one" })))))));
};
export default CalendarPopupDesk;
